// extracted by mini-css-extract-plugin
module.exports = {"SPTransformerVTComponent":"SPTransformerVoltageSelector__SPTransformerVTComponent___3wBGT"};